function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "mail",
  d: "M30.768,7H5.785A1.785,1.785,0,0,0,4,8.785V9.818a1.188,1.188,0,0,0,.449.93L17.183,20.892a1.746,1.746,0,0,0,2.187,0L32.1,10.75a1.191,1.191,0,0,0,.449-.93V8.785A1.785,1.785,0,0,0,30.768,7m1.785,6.148V26.63a1.785,1.785,0,0,1-1.785,1.785H5.785A1.785,1.785,0,0,1,4,26.63V13.148a.595.595,0,0,1,.966-.465L12.2,18.443a.595.595,0,0,1,.076.857L6.379,26.035l6.941-6.073a.6.6,0,0,1,.763-.018l2.359,1.88a2.936,2.936,0,0,0,3.669,0l2.359-1.88a.6.6,0,0,1,.763.018l6.941,6.073L24.28,19.3a.595.595,0,0,1,.077-.857l7.23-5.759a.595.595,0,0,1,.966.465",
  transform: "translate(-4 -7)",
  opacity: 0.5
});

function SvgIcMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.553,
    height: 21.415,
    viewBox: "0 0 28.553 21.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default ForwardRef;